module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"register_modal::cancel-button":"Отменить все изменения","register_modal::save-button":"Сохранить","register_modal::save_text":"Сохранение выполнено успешно"}}')
  delete Component.options._Ctor
}
